module.exports = __webpack_public_path__ + "static/media/indigo_logo.13d9b5d4.png";